let ecKeyName = [
  'prime256v1',
  'secp384r1',
  'secp521r1',
  'brainpoolP256r1',
  'brainpoolP384r1',
  'brainpoolP512r1'
]

export default ecKeyName
